import { useState, useEffect } from 'react'

export const useFetchAllManagements = ({marvarApi, dispatch, onLogout}) => {
    const [managements, setManagements] = useState([])
    const [loadingFetchManagements, setLoadingFetchManagements ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllManagements = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/credits/legal-credits/managements`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchManagements(true)
        fetchData()
            .then((resp) => {
                setManagements(resp.data)
                setLoadingFetchManagements(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchManagements(false)
            })
    }, [execute])

    return { managements, loadingFetchManagements, executeFetchAllManagements }

}

export const useFetchInfoContract = ({marvarApi, dispatch, onLogout, Forms, Helpers}) => {


    const {FormGlobal:{formState, setFormState}} = Forms

    const [ loadingData, setLoadingData ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoContract = async () => {
        setLoadingData(false)
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        if (formState.idcredito > 0) {
            try {
                const response = await marvarApi.get(`/credits/common/get-application-ID/${formState.idcredito}`)
                return response.data
            } catch (e) {
                console.log(e)
            }
        }else{
        }

    }

    useEffect(() => {
        if (formState.idcredito > 0) {
            fetchData()
                .then((resp) => {
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        cliente: data.cliente || '',
                        dpi: data.dpi || '',
                        tipo: data.tipo || '',
                        marca: data.marca || '',
                        linea: data.linea || '',
                        modelo: data.modelo || '',
                        matricula: data.matricula || '',
                        chasis: data.chasis || '',
                        motor: data.motor || '',
                        cilindros: data.cilindros || '',
                    }))
                    setLoadingData(true)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { loadingData, executeFetchInfoContract }

}


